<template>
	<div class="cst-product">
		<div class="goods-love-list s-row" v-if=" item.goods_numiid" v-for="(item, index) in product" :key="index" @click="detail(item.goods_numiid, item.goods_type)">
			<div class="image"><img :src="item.goods_picture"/></div>
			<div class="content">
				<div class="title">
<!-- 					<span class="tag" v-if="item.goods_shoptype">{{ item.goods_shoptype }}</span> -->
					{{ item.goods_title }}
				</div>
				<div class="product-amount">
					<div class="cstprice">
						<span>¥</span>
						{{ item.goods_yprice }}
					</div>
					<div class="tmprice" v-if="item.goods_price">{{ item.goods_shoptype }}价:¥{{ item.goods_price }}</div>
					<div class="tmprice" v-if="!item.goods_price">已售：{{ item.goods_sale }}</div>
				</div>
				<div class="product-volume" v-if="item.goods_price">已售：{{ item.goods_sale }}</div>
				<div class="product-coupon">
					<div class="coupon-money" v-if="item.coupon_money && item.coupon_money > 0">
						<span>{{ item.coupon_money }}元券</span>
					</div>
					<div class="product-shouyi" v-if="item.tkmoney">
						<span>预估收益:¥{{ item.tkmoney }}</span>
					</div>
					<div class="product-shouyi" v-else>
						<span>佣金:{{ item.tkrates }}%</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		product: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {};
	},
	methods: {
		detail(itemid, shopType) {
			this.$emit('detail', {
				itemid: itemid,
				shopType: shopType
			});
		}
	}
};
</script>

<style lang="less">

</style>
